module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Hillsdale College Press")]), _c('br'), _vm._v("33 East College Street"), _c('br'), _vm._v("Hillsdale, Michigan 49242"), _c('br'), _vm._v("www.hillsdale.edu")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Winston S. Churchill: World in Torment, 1916–1922 (Volume IV)")]), _c('br'), _vm._v("Copyright © 1975 C & T Publications Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Originally published in 1975 by William Heinemann Ltd. in Great Britain and by Houghton Mifflin in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. eBook edition published 2015 by Hillsdale College Press and RosettaBooks"), _c('br'), _vm._v("Cover art by Jirka Väätäinen (based on photograph from the Imperial War Museum, 28 October 1918)"), _c('br'), _vm._v("Cover design by Jay McNair"), _c('br'), _vm._v("ISBN e-Pub edition: 9780795344541")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("www.RosettaBooks.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99f713e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 66
// module chunks = 0